import apiFetch from '@wordpress/api-fetch';
import axios from 'axios';

import { IEUVA_Checkout_Params } from './interfaces/ieuva_checkout_params';
import { Checkout } from './classes/class.checkout';

// apiFetch.setFetchHandler( ( options ) => {
//     const { url, path, data, method } = options;

//     return axios( {
//         url: url || path,
//         method,
//         data,
//     } );
// } );

// Add a reference to the global parameters
declare global {
	var aelia_eu_vat_assistant_params: IEUVA_Checkout_Params;
	var jQuery: any;
}

(function ready(callback, args) {
  if(document.readyState != 'loading'){
		// If this function is called after the document has finished loading,
		// invoke the callback immediately
		callback(args);
	}
	else {
		// If the document is still loading, trigger the callback on the
		// "DOM loaded" event
		document.addEventListener('DOMContentLoaded', () => callback(args));
  }
})(Checkout.init, aelia_eu_vat_assistant_params);
